import React from "react";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import { translations } from "../containers/assets/translations";
import Autocomplete from "react-autocomplete";
import "../containers/MainAppContainer.css";

export default class SearchReservation extends React.Component {
  render() {
    let lang = this.props.lang;
    return (
      <div className="d-md-flex d-lg-block col-lg-12 col-md-12 col-sm-12 col-xs-12 flex-md-wrap flex-lg-nowrap align-items-end SearchOptions">
        <FormGroup bsSize="large" className="col-md-4 col-lg-3">
          <ControlLabel>{translations[lang]["Ticket Number"]}</ControlLabel>
          <FormControl
            value={this.props.ticketNumber}
            className="well"
            name="ticketNumber"
            type="text"
            onChange={event => {
              event.target.value = event.target.value.toUpperCase();
              this.props.handleChangeOfInput(event);
            }}
          />
        </FormGroup>
        <FormGroup bsSize="large" className="col-md-4 col-lg-3">
          <ControlLabel>{translations[lang]["PNR"]}</ControlLabel>
          <FormControl
            value={this.props.reservationNumber}
            autoFocus
            className="well"
            name="reservationNumber"
            type="text"
            onChange={event => {
              event.target.value = event.target.value.toUpperCase();
              this.props.handleChangeOfInput(event);
            }}
          />
        </FormGroup>
        <FormGroup bsSize="large" className="col-md-4 col-lg-3">
          <ControlLabel>{translations[lang]["Company"]}</ControlLabel>

          <Autocomplete
            className="col-md-3 col-sm-6 col-xs-12 form-group form-group-lg autocompleteClass"
            value={this.props.companyAbbreviation}
            onChange={(event, value) => {
              this.props.onChangeCompany(value);
            }}
            wrapperStyle = {
              {display: 'block'}
            }
            onSelect={(value, item) => {
              this.props.onChangeCompany(value);
            }}
             menuStyle= {
                {borderRadius: '3px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                background: 'rgba(255, 255, 255, 0.9)',
                padding: '2px 0',
                fontSize: '90%',
                position: 'fixed',
                overflow: 'auto',
                maxHeight: '50%',
                zIndex:1} }
  
            getItemValue={item => item[1].CompanyCode}
            inputProps={{
              className: "form-control well"
            }}
            items={this.props.noDuplicateCompanyAbbreviations}
            renderItem={(item, isHighlighted) => (
              <div
                id={item[1].CompanyCode}
                style={{
                  zIndex:1,
                  padding: 15,
                  background: isHighlighted ? "lightgray" : "white"
                }}
                key={item[1].ItineraryID}
              >
                {item[1].CompanyCode}
              </div>
            )}
          />
        </FormGroup>
        <div className="col-md-12 col-lg-3 form-group form-group-lg">
          <Button
            className="btn-primary"
            bsSize="large"
            type="button"
            onClick={() => {
              let validateSearch = this.props.validateSearch();
              if (validateSearch) this.props.fetchReservation();
            }}
          >
            {translations[lang]["Search Reservation"]}
          </Button>
        </div>
        <div className="col-12 col-md-6">
          <div className="group row" style={{ "marginLeft": "0px" }}>
            {(() => {
              const allTickets = [...this.props.personTickets, ...this.props.vehicleTickets];
              const statusCounts = allTickets.reduce(
                (acc, ticket) => {
                  acc[ticket.BoardStatus] = (acc[ticket.BoardStatus] || 0) + 1;
                  return acc;
                },
                {}
              );
              const statusLabels = {
                N: "New",
                A: "Printed",
                C: "Cancelled",
                S: "Boarded",
              };
              return Object.entries(statusLabels).map(([status, label]) => (
                <p key={status} className="col-auto" style={{"border": "1px solid #CED4DA", "borderRadius": "5px", "fontWeight": "bold", "marginRight": "5px" }}>
                  {label}: {statusCounts[status] || 0}
                </p>
              ));
            })()}
            <p className="col-auto" style={{"border": "1px solid #CED4DA", "borderRadius": "5px", "fontWeight": "bold"}}>
              Total: {this.props.personTickets.length + this.props.vehicleTickets.length}
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchReservation.js